<ng-container *transloco="let t">
  <div class="whitespace-pre-line w-full h-max max-h-screen flex flex-col relative text-mainTextLight">
    @if (modalData?.isClaimed && !hasActiveBonus) {
      <div
        class="bg-mainBtnLight flex justify-center items-baseline w-[12.75rem] md:w-[291px] h-10 rounded-b-[1.25rem] py-1.5 gap-2 justify-self-center absolute top-0 inset-1/2">
        <span>{{ t('buttons.Claimed') }}</span>
        <img src="https://cdn.chipychapa.com//welle/General_site/Advent/Winter/check.svg" />
      </div>
    }
    <div class="flex justify-end px-6 pt-6 pb-3">
      <img
        (click)="closeModal()"
        class="cursor-pointer"
        src="https://cdn.chipychapa.com//welle/General_site/Autharization/close_page.svg"
        alt="close" />
    </div>
    <div class="flex flex-col items-center px-6 pb-6 w-full gap-4 md:gap-6">
      @if (!hasActiveBonus) {
        <img class="w-20 h-20" [src]="modalData.image" />
        <span class="text-lg md:text-2xl !leading-7 font-semibold">{{ modalData.title }}</span>
        <span class="text-xs md:text-lg leading-4 font-normal">{{ modalData.text }}</span>
        <div class="flex flex-col items-start w-full gap-4 md:gap-6 text-sm md:text-xl">
          <span class="leading-6 md:leading-[2.125rem]">{{ modalData.subtitle }}</span>
          <span class="font-semibold">{{ modalData.rules }}</span>
        </div>
        @if (!modalData.isClaimed) {
          <app-main-button
            class="w-full"
            (click)="claimBonus()"
            [name]="'claim_bonus'"
            [variant]="'claimButton'"
            [id]="'claimAdventBonus'"></app-main-button>
        }
        <app-accordion-btn-inner-content [name]="t('buttons.Bonus terms')" [isAdvent]="true" class="w-full">
          <span class="font-normal text-xs md:text-lg md:leading-[1.125rem]">{{ modalData.bonusTerms }}</span>
        </app-accordion-btn-inner-content>
      }
      @if (hasActiveBonus) {
        <div class="gap-4 w-full items-center justify-center flex flex-col">
          <img height="96" width="96" ngSrc="noSearchResult" alt="noBonus" />
          <div class="flex flex-col items-center gap-4">
            <span class="dark:text-mainText text-mainTextLight text-sm md:text-xl font-bold text-center">
              {{ t('bonus.active_bonus.got_active') }}
            </span>
            <span class="dark:text-secondaryTextMain text-secondaryTextLight text-xs md:text-lg font-normal">
              {{ t('bonus.active_bonus.cancel_or_complete') }}
            </span>
          </div>
          <app-main-button
            name="active_bonuses"
            class="w-full"
            [variant]="'claimButton'"
            [url]="'/(aside:rewards/bonuses)'"
            (click)="closeModal()"></app-main-button>
        </div>
      }
    </div>
  </div>
</ng-container>
